<template>
  <div class="my-samples">
    <h2>Regional Tannin During Ripening (Niagara Region):</h2>
    <TanninDisplayPage mode="regional" userMode=""/>
  </div>
</template>

<script>
import TanninDisplayPage from '../components/TanninDisplayPage';

export default {
  name: 'Regional',
  components: {
    TanninDisplayPage,
  },
  mounted() {
    this.$store.dispatch('getLevels');
    this.$store.dispatch('getYears');
    this.$store.dispatch('getVarieties');
    this.$store.dispatch('getLocations');
    this.$store.dispatch('getLocationsAll');
    this.$store.dispatch('getSamplesPublic');
    this.$store.dispatch('getSamplesByUser', {
      user_id: this.$auth.user().id,
    });
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Regional.vue